<template>
	<page>
		<module ref="module" :drag="false" gap="10">
			<module-row>
				<module-col size="400" title="看板基础信息">
					<c-form ref="form" vertical unit-width="100%">
						<c-form-item label="看板标题名称" required>
							<c-input type="hidden" name="id"></c-input>
							<c-input name="title" maxlength="12"></c-input>
						</c-form-item>
						<c-form-item ref="layout" label="看板布局" name="layout" required tip="右键模块可自定义布局">
							<template #handle>
								<c-dropdown>
									<c-link color="main" style="line-height: 26px;">布局模板</c-link>

									<template #menu>
										<c-menu-list>
											<c-menu-item v-for="(item, i) in layoutTemplet" :key="i" @click="templetHandle(item)">{{item.name}}</c-menu-item>
										</c-menu-list>
									</template>
								</c-dropdown>
							</template>
							<div class="layout flex-column">
								<div v-for="(row, i) in layout" :key="i" class="layout-row flex flex-grow">
									<c-right-menu v-for="(col, j) in row" :key="j" class="flex-grow">
										<div class="layout-col flex-center" :class="{'z-crt': col == currentModule, 'z-empty': !moduleConfig[col.module_id]}" @click="switchModule(col)" @contextmenu="rightMenuTarget = {row: i, col: j, id: col.module_id, type: col.module_type}">
											<span>{{moduleName[col.module_type]}}</span>
										</div>

										<template #menu>
											<c-menu-list>
												<c-menu-group v-for="(group, i) in rightMenu" :key="i">
													<template v-for="(item, j) in group">
														<c-menu-list v-if="item.submenu" :key="j">
															<c-menu-item>{{item.name}}</c-menu-item>
															<template #menu>
																<c-menu-item v-for="(sub, k) in item.submenu" :key="k" @click="rightMenuHandle(sub)">{{sub.name}}</c-menu-item>
															</template>
														</c-menu-list>
														<c-menu-item v-else :key="j" @click="rightMenuHandle(item)">{{item.name}}</c-menu-item>
													</template>
												</c-menu-group>
											</c-menu-list>
										</template>
									</c-right-menu>
								</div>
							</div>
						</c-form-item>
						<c-form-item label="菜单名称" required>
							<c-input name="name" maxlength="8"></c-input>
						</c-form-item>
					</c-form>
				</module-col>
				<module-col class="module-config-box">
					<quota-config v-if="currentModule.module_type == 2" ref="config" :key="currentModule.module_id"></quota-config>
					<charts-config v-else-if="currentModule.module_type == 1" ref="config" :key="currentModule.module_id"></charts-config>
					<list-config v-else-if="currentModule.module_type == 3" ref="config" :key="currentModule.module_id"></list-config>
				</module-col>
				<template #button>
					<c-button v-if="auth('b_digital_config')" v-lock="lock('b_digital_config')" size="form" color="main" @click="submitHandle">保存</c-button>
					<c-button size="form" @click="navigateBack()">取消</c-button>
				</template>
			</module-row>
		</module>
	</page>
</template>

<script>
	import quotaConfig from './components/config_quota.vue'
	import chartsConfig from './components/config_charts.vue'
	import listConfig from './components/config_list.vue'
	import {createStore} from '@deanwu/vue-component-library'
	import layoutTemplet from './components/layout_templet.js'

	const dimensionResolveQueue = {};
	const quotaResolveQueue = {};

	export default {
		components: {
			quotaConfig,
			chartsConfig,
			listConfig
		},

		props: {
			id: String
		},

		data() {
			return {
				store: createStore({
					quotaDataSource: [],
					chartsDataSource: [],
					listDataSource: [],
					getDataSource: type => {
						if (this.store[`${type}DataSource`].length) return;
						this.request({
							url: '/digital/module/data/source',
							data: {
								module_type: {
									quota: 2,
									charts: 1,
									list: 3
								}[type]
							},
							success: data => {
								this.store.commit(`${type}DataSource`, data.map(item => {
									return {
										name: item.name,
										value: item.work_type_id
									}
								}));
							}
						})
					},

					dimensionData: {},
					getDimension: (module, dataType, source, resolve) => {
						if (!source || !dataType) return;
						let key = `${module}-${source}-${dataType}`;
						if (this.store.dimensionData[key]) {
							if (resolve) {
								resolve(this.store.dimensionData[key]);
							} else if (dimensionResolveQueue[key]) {
								dimensionResolveQueue[key].forEach(resolve => {
									resolve(this.store.dimensionData[key]);
								});
								delete dimensionResolveQueue[key];
							}
							return;
						}
						if (!dimensionResolveQueue[key]) {
							dimensionResolveQueue[key] = [];
							this.request({
								url: '/digital/module/data/dimensional',
								data: {
									module_type: module,
									work_type_id: source,
									data_type: dataType
								},
								success: data => {
									this.store.$set(this.store.dimensionData, key, data.map(item => {
										return {
											name: item.field_title,
											value: item.field_id,
											type: item.field_type == 1 || (item.field_type == 9 && item.config_json.type == 'text') ? 1 :
												item.field_type == 2 || (item.field_type == 9 && item.config_json.type == 'number') ? 2 :
												item.field_type == 3 || (item.field_type == 9 && item.config_json.type == 'time') ? 3 :
												item.field_type == 4 || (item.field_type == 9 && item.config_json.type == 'option') ? 4 : 0
										}
									}));
									this.store.getDimension.call(this, module, dataType, source);
								}
							})
						}
						dimensionResolveQueue[key].push(resolve);
					},

					quotaData: {},
					getQuota: (module, dataType, source, resolve) => {
						if (!source || !dataType) return;
						let key = `${module}-${source}-${dataType}`;
						if (this.store.quotaData[key]) {
							if (resolve) {
								resolve(this.store.quotaData[key]);
							} else if (quotaResolveQueue[key]) {
								quotaResolveQueue[key].forEach(resolve => {
									resolve(this.store.quotaData[key]);
								});
								delete quotaResolveQueue[key];
							}
							return;
						}
						if (!quotaResolveQueue[key]) {
							quotaResolveQueue[key] = [];
							this.request({
								url: '/digital/module/data/indicator',
								data: {
									module_type: module,
									work_type_id: source,
									data_type: dataType
								},
								success: data => {
									this.store.$set(this.store.quotaData, key, data.map(item => {
										return {
											name: item.field_title,
											value: item.field_id,
											type: item.field_type == 1 || (item.field_type == 9 && item.config_json.type == 'text') ? 1 :
												item.field_type == 2 || (item.field_type == 9 && item.config_json.type == 'number') ? 2 :
												item.field_type == 3 || (item.field_type == 9 && item.config_json.type == 'time') ? 3 :
												item.field_type == 4 || (item.field_type == 9 && item.config_json.type == 'option') ? 4 : 0
										}
									}));
									this.store.getQuota.call(this, module, dataType, source);
								}
							})
						}
						quotaResolveQueue[key].push(resolve);
					},

					quotaComputedOptions: (() => {
						let common = [{
							name: '计数',
							value: 'COUNT'
						}, {
							name: '去重后计数',
							value: 'DISTINCT_COUNT'
						}];
						let number = [{
							name: '求和',
							value: 'SUM'
						}, {
							name: '取平均值',
							value: 'AVG'
						}, {
							name: '取最小值',
							value: 'MIN'
						}, {
							name: '取最大值',
							value: 'MAX'
						}];

						return {
							0: common,
							1: common,
							2: common.concat(number),
							3: common,
							4: common
						}
					})(),

					refreshTimeOptions: [{
						name: '1分钟',
						value: 60
					}, {
						name: '5分钟',
						value: 300
					}, {
						name: '10分钟',
						value: 600
					}, {
						name: '30分钟',
						value: 1800
					}, {
						name: '1小时',
						value: 3600
					}]
				}),
				moduleName: {
					2: '指标区',
					1: '图表区',
					3: '报表区'
				},
				layoutTemplet,
				layout: [],
				rightMenuTarget: {},

				currentModule: {},
				moduleConfig: {}
			}
		},

		computed: {
			rightMenu() {
				let add = [{
					name: '指标区',
					handle: 2
				}, {
					name: '图表区',
					handle: 1
				}, {
					name: '报表区',
					handle: 3
				}];

				let list = [];
				list.push(add.filter(item => item.handle != this.rightMenuTarget.type).map(item => {
					return {
						name: '切换为' + item.name,
						handle: [item.handle]
					}
				}));

				if (
					this.rightMenuTarget &&
					(
						(this.rightMenuTarget.row == 0 && this.layout[0].length < 3) ||
						(this.rightMenuTarget.row == 1 && this.layout[1] && this.layout[1].length < 2)
					)
				) {
					list.push([{
						name: '在左边添加',
						submenu: add.map(item => {
							return {
								name: item.name,
								handle: ['left', item.handle]
							}
						})
					}, {
						name: '在右边添加',
						submenu: add.map(item => {
							return {
								name: item.name,
								handle: ['right', item.handle]
							}
						})
					}]);
				}

				if (this.layout.length < 2) {
					list.push([{
						name: '在上方添加模块',
						submenu: add.map(item => {
							return {
								name: item.name,
								handle: ['up', item.handle]
							}
						})
					}, {
						name: '在下方添加模块',
						submenu: add.map(item => {
							return {
								name: item.name,
								handle: ['down', item.handle]
							}
						})
					}]);
				}

				if (this.layout[0].length > 1 || this.layout[1]) {
					list.push([{
						name: '删除模块',
						handle: ['delete']
					}]);
				}

				return list;
			}
		},

		watch: {
			currentModule(val) {
				this.$nextTick(() => {
					this.$refs.config.setConfig(this.moduleConfig[val.module_id]);
				});
			}
		},

		mounted() {
			if (this.id != 'new') {
				this.request({
					url: '/digital/detail',
					data: {
						digital_id: this.id
					},
					loading: true,
					success: async data => {
						this.$refs.form.set(data);
						this.layout = data.config_json;

						for (let i = 0; i < data.module_list.length; i++) {
							let item = data.module_list[i];
							if (item.module_type == 2) {
								this.moduleConfig[item.module_id] = {
									type: 2,
									data: item.config_json.map(config => {
										return {
											name: config.title,
											source: config.work_type_id,
											quotaOptions: [],
											quota: config.count_fields[0].field_id,
											computedOptions: [],
											computed: config.count_fields[0].statistical_type,
											color: config.color,
											filter: config.filter_condition
										}
									})
								}
							} else if (item.module_type == 1) {
								this.moduleConfig[item.module_id] = {
									type: 1,
									data: item.config_json.map(config => {
										return {
											name: config.title,
											source: config.work_type_id,
											type: config.data_type,
											dimensionOptions: [],
											dimension: config.dimensional.field_id,
											format: config.dimensional.data_format,
											quotaOptions: [],
											quota1: config.count_fields[0].field_id,
											quota2: config.count_fields[1] ? config.count_fields[1].field_id : '',
											computedOptions: [],
											computed1: config.count_fields[0].statistical_type,
											computed2: config.count_fields[1] ? config.count_fields[1].statistical_type : '',
											total: config.total,
											refresh: config.refresh_time || 300,
											filter: config.filter_condition
										}
									})
								}
							} else if (item.module_type == 3) {
								let config = item.config_json[0];
								this.moduleConfig[item.module_id] = {
									type: 3,
									data: {
										name: config.title,
										source: config.work_type_id,
										field: await this.getTableFieldList(config.view_id),
										total: config.total,
										refresh: config.refresh_time || 300,
										autoScroll: config.auto_scroll || 1,
										autoSpan: config.auto_span || 3,
										filter: config.filter_condition,
										sort: config.sort_config
									}
								}
							}
						};
						this.$nextTick(() => {
							this.currentModule = this.layout[0][0];
						});
					}
				});
			} else {
				this.layout = layoutTemplet[0].value;
				this.$nextTick(() => {
					this.currentModule = this.layout[0][0];
				});
			}
		},

		methods: {
			getTableFieldList(id) {
				return new Promise(resolve => {
					this.request({
						url: '/sys_user_view/field_list',
						data: {
							view_id: id
						},
						success: data => {
							resolve(data.field_list);
						}
					});
				})
			},

			templetHandle(menu) {
				this.$confirm({
					message: '应用布局模板后已编辑的内容将会丢失，是否继续？',
					buttonName: '应用布局模板',
					resolve: () => {
						this.moduleConfig = {};
						this.layout = menu.value;
						this.currentModule = this.layout[0][0];
					}
				});
			},

			async rightMenuHandle(menu) {
				let module;
				switch (menu.handle[0]) {
				case 'left':
				case 'right':
					await this.saveModule();
					module = {
						module_id: this.newModuleId(),
						module_type: menu.handle[1]
					};
					this.layout[this.rightMenuTarget.row].splice(this.rightMenuTarget.col + (menu.handle[0] == 'right' ? 1 : 0), 0, module);
					this.currentModule = module;
					break;

				case 'up':
				case 'down':
					await this.saveModule();
					module = {
						module_id: this.newModuleId(),
						module_type: menu.handle[1]
					};
					this.layout[menu.handle[0] == 'up' ? 'unshift' : 'push']([module]);
					this.currentModule = module;
					break;

				case 'delete':
					if (this.layout[this.rightMenuTarget.row].length == 1) {
						this.layout.splice(this.rightMenuTarget.row, 1);
					} else {
						this.layout[this.rightMenuTarget.row].splice(this.rightMenuTarget.col, 1);
					}
					delete this.moduleConfig[this.rightMenuTarget.id];
					if (this.rightMenuTarget.id == this.currentModule.module_id) {
						this.currentModule = this.layout[0][0];
					}
					break;

				default:
					this.layout[this.rightMenuTarget.row][this.rightMenuTarget.col].module_type = menu.handle[0];
					delete this.moduleConfig[this.rightMenuTarget.id];
					this.$nextTick(() => {
						this.$refs.config.setConfig();
					});
					break;
				}
			},

			newModuleId() {
				let id = 1;
				while(this.layout.find(row => row.find(col => col.module_id == id))) {
					id++;
				};
				return id;
			},

			saveModule() {
				return new Promise(async resolve => {
					if (!this.$refs.config) {
						resolve();
						return;
					}
					let config = await this.$refs.config.getConfig();
					if (config) {
						this.moduleConfig[this.currentModule.module_id] = config;
						resolve();
					} else {
						this.$message({
							message: '请先完善当前模块的配置'
						});
					}
				})
			},

			async switchModule(item) {
				await this.saveModule();
				this.$refs.layout.warn(false);
				this.currentModule = item;
			},

			async submitHandle() {
				await this.saveModule();
				this.$refs.form.submit({
					url: '/digital/edit',
					rule: {
						title: '请填写看板标题名称',
						layout: () => {
							if (this.layout.find(row => row.find(col => !this.moduleConfig[col.module_id]))) {
								return '请完善红色区域的配置';
							}
							return true;
						},
						name: '请填写菜单名称'
					},
					dataFormatter: data => {
						data.config_json = this.layout;
						data.module_list = [];
						for (let id in this.moduleConfig) {
							let item = this.moduleConfig[id];
							if (item.type == 2) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: item.data.map(item => {
										return {
											title: item.name,
											work_type_id: item.source,
											data_type: 5,
											count_fields: [{
												field_id: item.quota,
												statistical_type: item.computed
											}],
											color: item.color,
											filter_condition: item.filter
										}
									})
								})
							} else if (item.type == 1) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									config_json: item.data.map(item => {
										return {
											title: item.name,
											work_type_id: item.source,
											data_type: item.type,
											dimensional: {
												field_id: item.dimension,
												data_format: item.format
											},
											count_fields: [{
												field_id: item.quota1,
												statistical_type: item.computed1
											}].concat(item.type == 4 ? [{
												field_id: item.quota2,
												statistical_type: item.computed2
											}] : []),
											total: item.total,
											refresh_time: item.refresh,
											filter_condition: item.filter
										}
									})
								})
							} else if (item.type == 3) {
								data.module_list.push({
									module_id: id,
									module_type: item.type,
									total: item.data.total,
									config_json: [{
										title: item.data.name,
										work_type_id: item.data.source,
										data_type: 6,
										total: item.data.total,
										refresh_time: item.data.refresh,
										filter_condition: item.data.filter,
										auto_scroll: item.data.autoScroll,
										auto_span: item.data.autoSpan,
										sort_config: item.data.sort,
										field_list: item.data.field
									}]
								})
							}
						}
						return data;
					},
					success: () => {
						this.$message({
							message: '保存成功'
						});
						this.$store.dispatch('updateLoginInfo');
						this.navigateBack();
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.layout {
		gap: 6px;
		box-sizing: border-box;
		height: 200px;
		border: 1px solid var(--unit-border);
		padding: 6px;

		&-row {
			gap: 6px;
			width: 100%;

			&:nth-child(1) {
				flex-grow: 1.2;
			}
		}

		&-col {
			height: 100%;
			border-radius: 4px;
			background: #eee;
			cursor: pointer;

			&.z-empty {
				background: rgba(255, 0, 0, .08);
			}

			&.z-crt {
				color: #fff;
				background: var(--color-main);
			}

			&:not(.z-crt):hover {
				color: var(--color-main);
			}
		}
	}

	.module-config {
		min-height: 100%;
		
		&-box {
			margin: 10px 0;
			background: none;
		}
	}
</style>